import { render, staticRenderFns } from "./CatalogueProduct.vue?vue&type=template&id=54ea3cfe&scoped=true&"
import script from "./CatalogueProduct.vue?vue&type=script&lang=js&"
export * from "./CatalogueProduct.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueProduct.vue?vue&type=style&index=0&id=54ea3cfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea3cfe",
  null
  
)

export default component.exports